import { useContext } from "react";
import { useQuery } from "@apollo/react-hooks";
import AppSyncApolloClientContext from "./AppSyncApolloClientContext";

export default (query, { ...rest }) => {
  const { client } = useContext(AppSyncApolloClientContext);
  return useQuery(query, { client, ...rest });
};
